import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store';
import layoutRoutes from '@/views/layout/routes';
import loginRoutes from '@/views/login/routes';
import printPreviewRoutes from '@/views/printPreview/routes';
import * as CONST from '@/const'
import { ModalServices } from '@/services/ModalServices';

let _routes: RouteRecordRaw[] = [];
_routes = _routes.concat(loginRoutes);
_routes = _routes.concat(printPreviewRoutes);
_routes = _routes.concat(layoutRoutes);

let _router = createRouter({
	history: createWebHashHistory(),
	routes: _routes,
	scrollBehavior: (to, from, savedPosition) => {
		window.scrollTo(savedPosition ? savedPosition.left : 0, savedPosition ? savedPosition.top : 0);
	}
});


function roleCanAccess(userRole: string, requiredRole: string): boolean {
	if(requiredRole == CONST.AppRoles.SuperAdmin){
		return userRole == CONST.AppRoles.SuperAdmin;
	} else if(requiredRole == CONST.AppRoles.Guest){
		return userRole == CONST.AppRoles.Guest;
	} else if(requiredRole == CONST.AppRoles.User){
		return userRole == CONST.AppRoles.SuperAdmin || userRole == CONST.AppRoles.User;
	}
	return false;
}

_router.beforeEach((to, from, next) => {
	if(to.meta.requiresAuth){
		if(!store.state.user){
			return next({ name: 'login' });
		}
	}
	if(to.meta.allowedRoles){
		const allowedRoles = <string[]>to.meta.allowedRoles;
		const userRole = store.state.user.role;
		const canAccess = allowedRoles.some(role => roleCanAccess(userRole, role));
		if(canAccess){
			next();
		}
	} else {
		next();
	}
})

_router.afterEach((to, from) => {
	ModalServices.closeAllModals();
})

let SuperAdminMenu = () => {
	return {
		systemPaths: [
			{ path: "/usersGlobal", name: "Utenti" },
			{ path: "/programSubscriptions", name: "Abbonamenti" },
			{ path: "/programSubscriptionTypes", name: "Tipi abbonamento" },
			{ path: "/appConfiguration", name: "Configurazione" },
			{ path: "/allOrders", name: "Ordini" },
			{ path: "/shopProductsConfigs", name: "Prodotti" },
			{ path: "/shopCategories", name: "Categorie" },
			{ path: "/mailEvents", name: "Mail Events" },
			{ path: "/pdfInterpolation", name: "Documenti e contratti" },
			{ path: "/qrConfigs/import", name: "Import QR" },
		],
		commessaPaths: [],
		vobisPaths: []
	}
}

function getSystemPaths(){
	let res = [
		{ path: "/license", name: "Licenze e piani" },
		{ path: "/profile", name: "Profilo" },
	];
	if(store.state.subscription){
		res.unshift({ path: "/commesse", name: "Commesse" })
	}
	return res;
}
function getCommessaPaths(){
	let res: { path: string, name: string }[] = [
		{ path: "/dashboard", name: "Home" },
		{ path: "/qrConfigs", name: "Gestione QR" },
		{ path: "/printTemplates", name: "Template di stampa" },
		{ path: "/orders", name: "Ordini" },
	];

	if(store.state.isCordova){
		res.push({ path: "/downloads", name: "File scaricati" });
	}

	if(store.state.isCommessaAdmin()){
		res.splice(1, 0, { path: "/users", name: "Utenti" });
	} else if(store.state.isCommessaEditor()){
		//
	} else if(store.state.isCommessaViewer()){
		//
	}
	return res;
}
function getVobisPaths(){
	return [
		{ path: "/catalogue", name: "Catalogo Vobis" },
	];
}

let UserMenu = () => {

	if(!store.state.subscription){
		
		if(!store.state.commesse.selectedCommessa){
			return {
				systemPaths: [
					{ path: "/license", name: "Licenze e piani" },
					{ path: "/profile", name: "Profilo" },
				],
				commessaPaths: [],
				vobisPaths: getVobisPaths()
			}
		} else {
			return {
				systemPaths: [
					{ path: "/license", name: "Licenze e piani" },
					{ path: "/profile", name: "Profilo" },
				],
				commessaPaths: getCommessaPaths(),
				vobisPaths: getVobisPaths()
			}
		}
	}

	let systemPaths = getSystemPaths();
	let commessaPaths = getCommessaPaths();
	let vobisPaths = getVobisPaths();

	return {
		systemPaths,
		commessaPaths,
		vobisPaths
	}
}

export function getMenuByRole(role: string){
	if(role == CONST.AppRoles.SuperAdmin){
		return SuperAdminMenu();
	} else if(role == CONST.AppRoles.User){
		return UserMenu();
	}
	return { systemPaths: [], commessaPaths: [], vobisPaths: [] };
}


export default _router;
